import type { Primitive } from "../types/primitives";


export type { Primitive } from "../types/primitives";

export type Node = Primitive | List | Object;

export type List = Node[];

export type Object = { [K in string]: Node; };
